<template>
    <div class="user_content_blcok">
        <div class="user_content_blcok_title">
            销售单查询
        </div>
        <div class="user_content_blcok_line"></div>
            <CoolLightBox 
            :items="items" 
            :index="index"
            @close="index = null">
            </CoolLightBox>
        <div style="float:right; margin-bottom:15px; margin:0 20px 20px 20px;">
            <el-form :inline="true" :model="listQuery" size="small" label-width="140px" style="float:left">
            <el-input v-model="listQuery.xsdjbh" size="mini" placeholder="请输入单据编号" @keyup.enter.native="handleSearchList" style="width:200px; margin-right:20px;"></el-input>
            <el-date-picker
              v-model="listQuery.createTime"
              type="daterange"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="center"
              size="mini"
               @keyup.enter.native="handleSearchList"
              >
            </el-date-picker>
            </el-form>

        <el-button
        style="margin-left:10px;"
          type="primary"
          icon="el-icon-search"
          @click="handleSearchList()"
          size="mini">
          查询
        </el-button> 
        <el-button @click="handleResetSearch()" icon="el-icon-refresh" size="mini">重置</el-button>
        </div>


        <!-- <div style="float:right; margin-bottom:15px; margin:0 20px 20px 20px;">
            <el-form :inline="true" :model="listQuery" size="small" label-width="140px" style="float:left">
            <el-input v-model="listQuery.djbh" placeholder="请输入单据编号" @keyup.enter.native="handleSearchList"></el-input>
            </el-form>

        <el-button
        style="margin-left:10px;"
          type="primary"
          icon="el-icon-search"
          @click="handleSearch()"
          size="small">
          查询
        </el-button>
        </div> -->
        <div class="user_content_blcok_line"></div>
        <div class="user_content_block_show">
      <div class="table-layout" v-if="list.length > 0">
        <el-row>
          <!-- <el-col :span="2" class="table-cell-title">序号</el-col> -->
          <el-col :span="8" class="table-cell-title">单据编号</el-col>
          <el-col :span="5" class="table-cell-title">汇总金额</el-col>
          <el-col :span="3" class="table-cell-title">日期</el-col>
          <el-col :span="8" class="table-cell-title">操作</el-col>
        </el-row>
        <el-row v-for="(v,k) in list" :key="k">
          <!-- <el-col :span="2" class="table-cell">{{v.rownumber}}</el-col> -->
          <el-col :span="8" class="table-cell">{{v.djbh}}</el-col>
          <!-- <el-col :span="4" class="table-cell">{{smallToBig(v.account)}}</el-col> -->
          <el-col :span="5" class="table-cell">{{v.hsje}}</el-col>
          <el-col :span="3" class="table-cell">{{v.rq}}</el-col>
          <el-col :span="8" class="table-cell">
            <el-button type="primary" @click="down_img(v)" size="mini" icon="el-icon-download">下载</el-button>
            <!-- <el-button type="primary" @click="down_excel(v)" size="mini">下载EXCEL</el-button> -->
            <el-button type="success" v-if="v.imgurl" @click="views_img(index,v)" size="mini" icon="el-icon-view">预览&nbsp;{{v.imgurl.length}}</el-button>
            <el-button type="success" v-else size="mini" icon="el-icon-view" disabled>未上传</el-button>
            <el-button type="primary" @click="views_list(v)" size="mini" icon="el-icon-plus">明细</el-button>
          </el-col>
        </el-row>
      </div>

        <div class="home_empty_list" v-else-if="list.length<=0">
            <i class="font iconfont">&#xe600;</i>无数据！
        </div>
            
        <div class="home_empty_list" v-else>
            <i class="font iconfont">&#xe600;</i>请选择日期查询两票_销售单查询！
        </div>




        </div>

    </div>
</template>


<script>
import ShopTop from "@/components/home/public/head.vue"
import ShopFoot from "@/components/home/public/shop_foot.vue"
import ShopMbar from "@/components/home/public/mui_mbar_tabs.vue"
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
// import { numToCny } from '@/utils/mony.js'
  const defaultListQuery = {
    createTime:null,
    starttime: null,
    endtime: null,
    xsdjbh:'',
    // pageSize:10,
    // pages:1,
  };
export default {
    components: {
        ShopTop,
        ShopFoot,
        ShopMbar,
        CoolLightBox
    },
    props: {},
    data() {
      return {
          dialogVisible:false,
          edit_id:0,
          list:[],
          items: [],
          index: null,
          total_data:0, // 总条数
          pageSize:10,
          listQuery: Object.assign({}, defaultListQuery),
          preStoreUtils: {
              cardNumber:null,
              openingBank:null
          },
          createTime:[],
          pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近六个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
      };
    },
    watch: {
    },
    computed: {},
    methods: {
            smallToBig(money) {
                            // 汉字的数字
                            const cnNums = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];
                            // 基本单位
                            const cnIntRadice = ["", "拾", "佰", "仟"];
                            // 对应整数部分扩展单位
                            const cnIntUnits = ["", "万", "亿", "兆"];
                            // 对应小数部分单位
                            const cnDecUnits = ["角", "分"];
                            // 整数金额时后面跟的字符
                            const cnInteger = "整";
                            // 整型完以后的单位
                            const cnIntLast = "元";
                            // 最大处理的数字
                            const maxNum = 9999999999999999.99;
                            // 金额整数部分
                            let integerNum;
                            // 金额小数部分
                            let decimalNum;
                            // 输出的中文金额字符串
                            let chineseStr = "";
                            // 分离金额后用的数组，预定义
                            let parts;
                            if (money === "") {
                                return "";
                            }
                            money = parseFloat(money);
                            if (money >= maxNum) {
                                // 超出最大处理数字
                                return "";
                            }
                            if (money === 0) {
                                chineseStr = cnNums[0] + cnIntLast + cnInteger;
                                return chineseStr;
                            }
                            // 转换为字符串
                            money = money.toString();
                            if (money.indexOf(".") === -1) {
                                integerNum = money;

                                decimalNum = "";
                            } else {
                                parts = money.split(".");
                                integerNum = parts[0];
                                decimalNum = parts[1].substr(0, 4);
                            }
                            // 获取整型部分转换
                            if (parseInt(integerNum, 10) > 0) {
                                let zeroCount = 0;
                                const IntLen = integerNum.length;
                                for (let i = 0; i < IntLen; i++) {
                                    const n = integerNum.substr(i, 1);
                                    const p = IntLen - i - 1;
                                    const q = p / 4;
                                    const m = p % 4;
                                    if (n === "0") {
                                        zeroCount++;
                                    } else {
                                        if (zeroCount > 0) {
                                            chineseStr += cnNums[0];
                                        }
                                        // 归零
                                        zeroCount = 0;
                                        //alert(cnNums[parseInt(n)])
                                        chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
                                    }
                                    if (m === 0 && zeroCount < 4) {
                                        chineseStr += cnIntUnits[q];
                                    }
                                }
                                chineseStr += cnIntLast;
                            }
                            // 小数部分
                            if (decimalNum !== "") {
                                const decLen = decimalNum.length;
                                for (let i = 0; i < decLen; i++) {
                                    const n = decimalNum.substr(i, 1);
                                    if (n !== "0") {
                                        chineseStr += cnNums[Number(n)] + cnDecUnits[i];
                                    }
                                }
                            }
                            if (chineseStr === "") {
                                chineseStr += cnNums[0] + cnIntLast + cnInteger;
                            } else if (decimalNum === "") {
                                chineseStr += cnInteger;
                            }
                            return chineseStr;
                        },

        // 分页改变
        current_change:function(e){
            this.current_page = e;
            this.get_user_order();
            this.$scrollTo();
        },

        //搜索
        handleSearchList() {
            // if(this.listQuery.createTime == null){
            //     return alert('请先选择时间范围!')
            // }else{
                this.getList();
            // }
            
        },
        
         //重置搜索
        handleResetSearch() {
            // this.listQuery.starttime = '';
            // this.listQuery.endtime = '';
            // this.listQuery.xsdjbh = '';
            // this.setTime = '';
            // this.endtime = '';
            this.listQuery.xsdjbh = '';
            this.listQuery.createTime = '';
            this.listQuery = Object.assign({}, defaultListQuery);
            this.getList();
        },


        getList:function(){
            if(this.listQuery.createTime == null){
                this.listQuery.createTime = [];
                this.listQuery.createTime[0] = '';
                this.listQuery.createTime[1] = '';
            }
            this.$get(this.$api.LP_xsdcx,{
                starttime:this.listQuery.createTime[0],
                endtime:this.listQuery.createTime[1],
                type:0,
                xsdjbh:this.listQuery.xsdjbh,
                platId:this.$platId,
            }).then(res=>{
                if(res.code == 200){
                    if(res.data != ''){
                        this.list = res.data;
                    }else{
                        this.$message.success(res.message);
                        this.list = null;
                    }
                }else{
                    this.$message.error(res.message);
                }

            });
        },
        
        //查看税票及随货同行单
        views_img(index,v){
            this.index = 0;
            this.items = v.imgurl;
        },



        //按单据标号查询
        handleSearch() {
            let routeData = this.$router.resolve({ path: '/user/LP_xsdcx_Details', query: {djbh:this.listQuery.djbh}});
            window.open(routeData.href, '_blank');
        },

        //当前ID信息
        views_list:function(v){
            let routeData = this.$router.resolve({ path: '/user/LP_xsdcx_Details', query: {djbh:v.djbh}});
            window.open(routeData.href, '_blank');
        },

          //下载文件
        // down_img:function(v){
        //     this.$post(this.$api.LP_DownLoad,{djbh:v.djbh}).then(res=>{
        //         console(res);
        //     });
        //     // window.open(routeData.href, '_blank');
        //     // this.$get(this.$api.LP_DownLoad).then(res=>{
        //     //     console(res);
        //     // });
        // },


        down_img:function(v){
        this.$confirm('文件可能过多，需要一些时间，请您耐心等待?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
                    let a = document.createElement('a')
                    a.href = this.$api.baseUrl+'kxorders/userOrder/LP_DownLoad?djbh='+v.djbh,
                    a.click();


            })
         },


        close_dialog:function(){
            this.edit_id = 0;
        }
    },
    created() {
        //this.getList(); 
        // this.getCounts();
        
    },
    mounted() {}
};
</script>
<style lang="scss" scoped>
.user_address_list{
    padding-top: 10px;
    ul li{
        margin-bottom: 20px;
        padding-bottom: 20px;
        border-bottom: 1px solid #efefef;
        dl{
            float: left;
            display: block;
            width: 650px;
            dt{
                margin-right: 20px;
                font-size: 14px;
                line-height: 30px;
            }
            dd{
                line-height: 20px;
                width: 190px;
                width: 500px;
                float: left;
            }
            dd.address_info{
                color:#999;
                float: left;
                width:100%;
                width: 500px;
            }
        }
        .address_handle{
            color:#666;
            float:right;
            line-height: 40px;
            span{
                margin: 0 10px; 
                i{
                    margin-right: 10px;
                }
                
            }
            span:hover{
                color:#F56C6C;
            }
            span.red{
                color:#F56C6C;
            }
        }
    }

}
    select{
        height: 32px !important;
        line-height: 32px !important;
        padding: 0 !important;
    }
   .home_form_main .el-input, .el-textarea {
        max-width: 250px;
        height: 32px;
        line-height: 32px;
    }
   .home_form_main .el-input--small .el-input__inner {
        max-width: 250px;
        height: 32px;
        line-height: 32px;
        }
.el-cascader {
    display: inherit;
    position: relative;
    font-size: 14px;
    line-height: 32px;
    height: 32px;
    max-width: 250px;
}   

.table-layout {
    margin-top: 20px;
    border-left: 1px solid #EBEEF5;
    border-top: 1px solid #EBEEF5;
background: url(data:image/jpeg;base64,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);
}

  .table-cell {
    height: 48px;
    line-height: 48px;
    border-right: 1px solid #EBEEF5;
    border-bottom: 1px solid #EBEEF5;
    font-size: 14px;
    color: #606266;
    text-align: center;
    overflow: hidden;
  }
  .table-cell p{
    line-height: 35px;
  }
  .table-cell-title {
    border-right: 1px solid #EBEEF5;
    border-bottom: 1px solid #EBEEF5;
    height: 48px;
    line-height: 48px;
    background: #f5f7fa;
    text-align: center;
    font-size: 14px;
    color: #909399;
  }

</style>


<style>
body{font-family: 微软雅黑;font-size: 13px; color: #000000; /*background: #efefef;*/}
table { border-collapse: collapse; margin: 10px 0; padding: 20px 0; height: 80px;}
.fl{float: left; text-align: left;}
.fr{float: right; text-align: right;}

.list_contact{width: 1200px; margin: 0 auto; padding:10px 10px; background:#fff;}
.header{width: 1200px; height: 50px;}
.header img{width: 100%;}
.footer{width: 1200px;}
.footer p{height: 15px; line-height: 15px; margin: 2px 5px; text-align: justify;}
.footer p span{margin: 0 0 0 0px;}
.footer p span:first-child{margin: 0 50px 0 0px;}
.footer p span:nth-child(2n){margin: 0 50px 0 0px;}
.footer p span:nth-child(3n){margin: 0 50px 0 0px;}
.footer p span:nth-child(4n){margin: 0 50px 0 0px;}
.footer p span.strong{font-weight: bold; font-size: 14px; color: #000000}
.footer .page{text-align: right; float: right;}
.title1{height: 30px;}
.title1 p{height: 15px; line-height: 15px; margin: 5px 5px; }
.title1 p span{margin: 0 0 0 30px;}
.singular_title{ font-size:30px; /*font-weight: bold;*/ text-align: center; height:50px; line-height: 50px;}
	
	
.list-pro-table{margin-top: 15px; width: 100%;}
.list-pro-table td{font-size: 14px; color: #666666; text-align: left; border: 1px solid #E6E6E6; line-height: 35px; padding: 5px 10px; font-weight: normal;}
.list-pro-table td:first-child{width: 60px; text-align: right;}
.list-pro-table td:last-child{width: 126px; text-align: center; padding: 0 10px;}
.list-pro-table td button,.list-pro-table td a{background: #14a8f4;padding: 5px 10px;color: #fff !important;border-radius: 2px;text-decoration: none !important; margin-right: 10px; border:none; cursor: pointer;}
.list-pro-table td button:hover,.list-pro-table td a:hover{background: #ff6c00;}
.list-pro-table td p{text-indent: 10px;}
.list-pro-table td input{height: 30px;line-height: 30px;text-indent: 10px;border: 1px solid #E6E6E6;border-radius: 4px; width:120px;}
.list-pro-table td select{height: 32px;line-height: 32px;border: 1px solid #E6E6E6;border-radius: 4px; text-align: center; padding: 0 10px; }
.list-pro-table td.name-left{width:150px;}
.list-pro-table td.name-right{width:326px; padding: 0 20px; text-align: left;}
.list-pro-table td.singular{background: #fafafa; padding: 0 5px; text-align: center; height: 50px; line-height: 50px;}
	
	
.mt20{margin-bottom: 20px;}
.search{margin-right: 10px;}
.search input{height: 32px; line-height: 32px; border-radius: 4px; width: 300px;  border: 1px solid #dcdfe6; padding: 0 10px; outline: none; color: #666666; font-size: 14px;}
.searc_btn{margin-left: 10px;}	
.searc_btn input{height: 34px; line-height: 34px; background: #14a8f4; padding: 0 20px; border: none; border-radius: 2px; color: #fff; cursor: pointer; margin-left: 10px; }		
.date input{padding-left: 10px; height: 30px; width: 100px !important; line-height: 30px; border: 1px solid #dcdfe6; border-radius: 2px;outline: none; margin: 0 15px; font-size: 14px; color: #666666; cursor: pointer;}
	
.pages{ float: right; height: 45px; line-height: 45px;}
.pages a{cursor: pointer;}
</style>



<style>
@media screen{
html{background:#fff;}
body{font-family: "Arial";font-size: 12px; color: #000000;}
table { border-collapse: collapse; margin: 10px 0; padding: 20px 0; margin-left: 10px;}
.fl{float: left; text-align: left;}
.fr{float: right; text-align: right;}
.chapter{width: 1200px; margin: 0 auto; z-index: 9999;}
.chapter img{width: 350px; height: 240px; margin: 0 auto; position: absolute;z-index: 9999; float: right; margin-left: 750px; margin-top: 150px;}
/* .contact{width: 1200px; margin: 0 auto; height: 828px;} */
.header{width: 1200px; height: 70px;}
.header img{width: 100%;}
.footer{width: 1200px; margin-left: 10px;}
.footer p{height: 15px; line-height: 15px; margin: 2px 5px; text-align: justify;}
.footer p span{margin: 0 0 0 0px;}
.footer p span:first-child{margin: 0 50px 0 0px;}
.footer p span:nth-child(2n){margin: 0 50px 0 0px;}
.footer p span:nth-child(3n){margin: 0 50px 0 0px;}
.footer p span:nth-child(4n){margin: 0 50px 0 0px;}
.footer p span.strong{font-weight: bold; font-size: 14px; color: #000000}
.footer .page{text-align: right; float: right;}
.title1{margin-left: 10px;}
.title1 p{height: 15px; line-height: 15px; margin: 5px 5px; }
.singular_title{ font-size:20px; font-weight: bold; text-align: center; height:40px; line-height: 40px; text-align: right; margin-right: 130px;}
.singular_title .bar_code{margin: 0 10px; width: 180px; height: 26px; line-height: 26px;}
.singular_title .bar_code img{width: 180px; height: 26px; line-height: 26px; margin-bottom: -5px;}
.singular_title .label_num{margin-left: 80px; margin-right: 50px; font-size: 16px;}
	
.detail-table{margin-top: 15px; width: 100%;}
.detail-table td{ color: #212121; text-align: left; border: 1px solid #212121; font-size: 12px; line-height: 14px; padding: 3px; font-weight: normal;}
.detail-table td:nth-child(2n){width: 70px; text-align: center; border-right: 2px solid #212121;}
.detail-table td:nth-child(4n){width: 38px; text-align: center;}
.detail-table td:nth-child(5n){width: 60px; text-align: center;}
.detail-table td:nth-child(6n){text-align: center;  border-right: 2px solid #212121;}
.detail-table td:nth-child(7n){width: 60px; text-align: center;}
.detail-table td:nth-child(8n){width: 30px; text-align: center;}
.detail-table td:nth-child(9n){width: 30px; text-align: center;}
.detail-table td:nth-child(10n){width: 40px; text-align: center;}
.detail-table td:nth-child(11n){width: 60px; text-align: center;}
.detail-table td:nth-child(12n){width: 60px; text-align: center;  border-right: 2px solid #212121;}
.detail-table td:nth-child(13n){width: 80px; text-align: center;}
.detail-table td:last-child{width: 30px; text-align: center; border-left: 2px solid #212121;}
.detail-table td a{background: #14a8f4;padding: 5px 10px;color: #fff !important;border-radius: 4px;text-decoration: none !important; margin-right: 10px;}
.detail-table td a:hover{background: #ff6c00;}
.detail-table td p{text-indent: 10px;}
.detail-table td input{height: 30px;line-height: 30px;text-indent: 10px;border: 1px solid #212121;border-radius: 4px; width:120px;}
.detail-table td select{height: 32px;line-height: 32px;border: 1px solid #212121;border-radius: 4px; text-align: center; padding: 0 10px; }
.detail-table td.name-left{width:150px;}
.detail-table td.name-right{width:326px; padding: 0 20px; text-align: left;}
.detail-table td.singular{/*background: #ececec;*/ padding:0; text-align: center; height: 25px; line-height: 25px; }
.print{width: 1200px; margin: 50px auto 50px auto; clear: both; height: 100px; text-align: right; z-index: 9999;}
.layui-layer-btn0{ margin:50px 10px 20px 0; border: none; border-radius: 4px; padding: 10px 20px; cursor: pointer; background: #14a8f4; color: #fff; outline: none;}

}
@media print{
@page {
    size: A4 landscape;      
    margin: 5mm 2mm 5mm 2mm;
    font-family: "Arial";
    font-size: 12px;
}
html{background:#fff;}
body{font-family: "Arial";font-size: 12px; color: #000000; max-width: 1200px;}
table { border-collapse: collapse; margin: 10px 0; padding: 20px 0; margin-left: 10px;}
.fl{float: left; text-align: left;}
.fr{float: right; text-align: right;}
.chapter{width: 1200px; margin: 0 auto; z-index: 9999;}
.chapter img{width: 350px; height: 240px; margin: 0 auto; position: absolute;z-index: 9999; float: right; margin-left: 750px; margin-top: 150px;}
/* .contact{width: 1200px; margin: 0 auto;height: 828px;} */
.header{width: 1200px; height: 70px;}
.header img{width: 100%;}
.footer{width: 1200px; margin-left: 10px;}
.footer p{height: 15px; line-height: 15px; margin: 2px 5px; text-align: justify;}
.footer p span{margin: 0 0 0 0px;}
.footer p span:first-child{margin: 0 50px 0 0px;}
.footer p span:nth-child(2n){margin: 0 50px 0 0px;}
.footer p span:nth-child(3n){margin: 0 50px 0 0px;}
.footer p span:nth-child(4n){margin: 0 50px 0 0px;}
.footer p span.strong{font-weight: bold; font-size: 14px; color: #000000}
.footer .page{text-align: right; float: right;}
.title1{margin-left: 10px;}
.title1 p{height: 15px; line-height: 15px; margin: 5px 5px; }
.singular_title{ font-size:20px; font-weight: bold; text-align: center; height:40px; line-height: 40px; text-align: right; margin-right: 130px;}
.singular_title .bar_code{margin: 0 10px; width: 180px; height: 26px; line-height: 26px;}
.singular_title .bar_code img{width: 180px; height: 26px; line-height: 26px; margin-bottom: -5px;}
.singular_title .label_num{margin-left: 80px; margin-right: 50px; font-size: 16px;}
	
.detail-table{margin-top: 15px; width: 100%;}
.detail-table td{ color: #212121; text-align: left; border: 1px solid #212121; font-size: 12px; line-height: 14px; padding: 3px; font-weight: normal;}
.detail-table td:nth-child(2n){width: 70px; text-align: center; border-right: 2px solid #212121;}
.detail-table td:nth-child(4n){width: 38px; text-align: center;}
.detail-table td:nth-child(5n){width: 60px; text-align: center;}
.detail-table td:nth-child(6n){text-align: center;  border-right: 2px solid #212121;}
.detail-table td:nth-child(7n){width: 60px; text-align: center;}
.detail-table td:nth-child(8n){width: 30px; text-align: center;}
.detail-table td:nth-child(9n){width: 30px; text-align: center;}
.detail-table td:nth-child(10n){width: 40px; text-align: center;}
.detail-table td:nth-child(11n){width: 60px; text-align: center;}
.detail-table td:nth-child(12n){width: 60px; text-align: center;  border-right: 2px solid #212121;}
.detail-table td:nth-child(13n){width: 80px; text-align: center;}
.detail-table td:last-child{width: 30px; text-align: center; border-left: 2px solid #212121;}
.detail-table td a{background: #14a8f4;padding: 5px 10px;color: #fff !important;border-radius: 4px;text-decoration: none !important; margin-right: 10px;}
.detail-table td a:hover{background: #ff6c00;}
.detail-table td p{text-indent: 10px;}
.detail-table td input{height: 30px;line-height: 30px;text-indent: 10px;border: 1px solid #212121;border-radius: 4px; width:120px;}
.detail-table td select{height: 32px;line-height: 32px;border: 1px solid #212121;border-radius: 4px; text-align: center; padding: 0 10px; }
.detail-table td.name-left{width:150px;}
.detail-table td.name-right{width:326px; padding: 0 20px; text-align: left;}
.detail-table td.singular{/*background: #ececec;*/ padding:0; text-align: center; height: 25px; line-height: 25px; }
.print{width: 1200px; margin: 50px auto 50px auto; clear: both; height: 100px; text-align: right; z-index: 9999;}
.layui-layer-btn0{ margin:50px 10px 20px 0; border: none; border-radius: 4px; padding: 10px 20px; cursor: pointer; background: #14a8f4; color: #fff; outline: none;}
}
</style>


<style>
 .dialogClass{
      width: 60vh;
      overflow: auto;
    }
 .el-dialog{
    width:1300px !important;
   }
   .user_content_blcok{
       width: 890px;
   }
</style>